import { render } from "./SectionConferenceReservation.vue?vue&type=template&id=476de172&scoped=true"
import script from "./SectionConferenceReservation.vue?vue&type=script&lang=js"
export * from "./SectionConferenceReservation.vue?vue&type=script&lang=js"

import "./SectionConferenceReservation.vue?vue&type=style&index=0&id=476de172&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476de172"]])

export default __exports__